/**
 * Detects if the user is using an in-app browser (like Facebook, Instagram, etc.)
 * These browsers often have compatibility issues with authentication flows
 */
export function isInAppBrowser(): boolean {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Detect Facebook in-app browser
  const isFacebookBrowser = /FBAN|FBAV/i.test(ua);

  // Detect Instagram in-app browser
  const isInstagramBrowser = /Instagram/i.test(ua);

  // Detect LinkedIn in-app browser
  const isLinkedInBrowser = /LinkedIn/i.test(ua);

  // Detect Twitter/X in-app browser
  const isTwitterBrowser = /Twitter/i.test(ua);

  // Detect TikTok in-app browser
  const isTikTokBrowser = /TikTok/i.test(ua);

  return (
    isFacebookBrowser ||
    isInstagramBrowser ||
    isLinkedInBrowser ||
    isTwitterBrowser ||
    isTikTokBrowser
  );
}

/**
 * Gets the name of the in-app browser for display purposes
 */
export function getInAppBrowserName(): string {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/FBAN|FBAV/i.test(ua)) return 'Facebook';
  if (/Instagram/i.test(ua)) return 'Instagram';
  if (/LinkedIn/i.test(ua)) return 'LinkedIn';
  if (/Twitter/i.test(ua)) return 'Twitter/X';
  if (/TikTok/i.test(ua)) return 'TikTok';

  return 'in-app browser';
}

/**
 * Gets instructions for opening in default browser based on platform
 */
export function getOpenInBrowserInstructions(): {
  platform: string;
  steps: string[];
} {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  const isAndroid = /android/i.test(ua);

  if (isIOS) {
    return {
      platform: 'iOS',
      steps: [
        'Tap the three dots (•••) menu',
        'Select "Open in Safari" or "Open in Browser"',
        'You will be redirected to Safari where everything works properly',
      ],
    };
  }

  if (isAndroid) {
    return {
      platform: 'Android',
      steps: [
        'Tap the three dots (⋮) menu',
        'Select "Open in Chrome" or "Open in external browser"',
        'You will be redirected to Chrome where everything works properly',
      ],
    };
  }

  return {
    platform: 'Desktop',
    steps: [
      'Please open this link in your regular browser (Chrome, Firefox, Safari, Edge)',
    ],
  };
}
